var $d5ab76bcbadc9c07$exports = {};
$d5ab76bcbadc9c07$exports = {
    "breadcrumbs": `S\xf6kv\xe4gar`
};


export {$d5ab76bcbadc9c07$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
